import { DOCUMENT } from '@angular/common';
import { Injectable, inject } from '@angular/core';

/**
 * Moves a DOM subtree to `document.body` so `position: fixed` overlays stack above
 * app-level chrome (e.g. sticky headers with z-index ~1000) that wrap `router-outlet`.
 */
@Injectable({ providedIn: 'root' })
export class CanvasBodyPortalService {
  private readonly document = inject(DOCUMENT);

  attach(element: HTMLElement): () => void {
    const parent = element.parentNode;
    const next = element.nextSibling;
    this.document.body.appendChild(element);
    return () => {
      if (parent) {
        parent.insertBefore(element, next);
      }
    };
  }
}
